import { createAction } from 'redux-actions';

export const GET_CATEGORY_REQUEST = createAction('GET_CATEGORY_REQUEST');
export const GET_CATEGORY_FAILURE = createAction('GET_CATEGORY_FAILURE');
export const GET_CATEGORY_SUCCESS = createAction('GET_CATEGORY_SUCCESS');
